import React, { memo, useState, useEffect } from "react";
// import quotesData from "./data/quotes.json";
import { MyQuotesTableMain } from "./styles/MyQuotesTableStyles";
import TableMain from "../shared/TableMain";

const MyQuotesTable = ({
  data = [],
  CurrentPage,
  setCurrentPage,
  Last_page,
  total_pages,
}) => {
  const [OrdersData, SetOrdersData] = useState([]);

  useEffect(() => {
    if (data && data?.length > 0) {
      const modifiedData = data?.map((values) => {
        const Sender = values?.stops[0]?.contact_name;
        const order_id = values?.order_id;
        const created_at = values?.created_at;
        const Receiver = values?.stops[1]?.contact_name;

        const Order = values?.stops[0]?.order_detail?.name;
        const order_type = values?.order_type;
        // const Price = values?.price;
        const status = values?.status;
        // const Driver = values?.driver_name;

        // Remove the "stops" array from the object using destructuring
        // const { stops, ...modifiedValues } = values;

        return {
          // ...modifiedValues,
          order_id,
          created_at,
          Sender,
          Receiver,
          Order,
          order_type,
          // Driver,
          // Price,
          status,
        };
      });

      // Update the OrdersData state with the modified array
      SetOrdersData(modifiedData || []);
    }
  }, [data]);

  const TableHeadData = [
    { title: "ID", val: "order_id" },
    { title: "Date & Time", val: "created_at" },
    { title: "Sender", val: "Sender" },
    { title: "Receiver", val: "Receiver" },
    { title: "Type", val: "order_type" },
    { title: "Order", val: "Order" },
    { title: "Status", val: "status" },
  ];

  return (
    <>
      {OrdersData.length > 0 && (
        <>
          <MyQuotesTableMain>
            <TableMain
              TableHeadData={TableHeadData}
              BodyData={OrdersData}
              TableType="dispatches/myquotes"
              CurrentPage={CurrentPage}
              setCurrentPage={setCurrentPage}
              Last_page={Last_page}
              total_pages={total_pages}
            />
          </MyQuotesTableMain>
        </>
      )}
    </>
  );
};

export default memo(MyQuotesTable);
